import { render } from "./mvt-collapsiblelinks.vue?vue&type=template&id=54409f53"
import script from "./mvt-collapsiblelinks.js?vue&type=script&lang=js"
export * from "./mvt-collapsiblelinks.js?vue&type=script&lang=js"

import "./mvt-collapsiblelinks.vue?vue&type=style&index=0&id=54409f53&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__